import styled from 'styled-components';

export const WrapVideo = styled.div`
    padding: 0px !important;
    height: 500px;
    @media(max-width: 576px){
        height: auto;
        width: auto !important;
    }
`;